
import listArrange from '@/components/temporary/list-arrange'

import listHeader from '@/components/temporary/list-header'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template';
import Badge from 'vux/src/components/badge/index.vue'


export default {
name: "priceTp",
data() {
return {
listHeaderTemplateBoard: {},
listArrange: [],
approvalTemplateBoard: {}
}
},
props: ['data',],
created() {
let templateData = this.data;
this.listHeaderTemplateBoard = {
template: listHeaderTemplate.contractQuery,
data() {
return {
title: templateData.matName,
desc:templateData.supplierName
}
}
},
this.listArrange = [
{
icon: "fa fa-calendar-check-o font-size-mr",
templateBoard: {
template: "<span class=\"fn_12\">{{lastModifiedDate | dateFormat('YYYY-MM-DD')}} ~ {{ModifiedDate | dateFormat('YYYY-MM-DD')}}</span>",
data() {
return {
lastModifiedDate: templateData.startDate,
ModifiedDate: templateData.endDate,
}
},
},
span: 24
},
]
},
methods: {},
components: {
listArrange,

divSpan,
listHeaderTemplate,
listHeader
}
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/material-source-allocation-tp.vue